export const types = {
    FETCH_EMAIL_LOGS: 'FETCH_EMAIL_LOGS',
    FETCH_EMAIL_LOGS_SUCCESS: 'FETCH_EMAIL_LOGS_SUCCESS',
    FETCH_EMAIL_LOGS_FAIL: 'FETCH_EMAIL_LOGS_FAIL',
    FETCH_EMAIL_LOG_STATS: 'FETCH_EMAIL_LOG_STATS',
    FETCH_EMAIL_LOG_STATS_SUCCESS: 'FETCH_EMAIL_LOG_STATS_SUCCESS',
    FETCH_EMAIL_LOG_STATS_FAIL: 'FETCH_EMAIL_LOG_STATS_FAIL',
};

export interface IEmailLog {
    _id: string;
    user?: {
        _id: string;
        firstName?: string;
        lastName?: string;
        userName?: string;
        email?: string;
    };
    email: string;
    type: string;
    opened: boolean;
    openedAt?: string;
    invalidAddress: boolean;
    sendGridMessageId?: string;
    subject?: string;
    createdAt: string;
    updatedAt: string;
}

export interface IFetchEmailLogsPayload {
    page?: number;
    limit?: number;
    searchTerm?: string;
    type?: string;
    opened?: boolean | string;
    invalidAddress?: boolean | string;
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface IEmailLogsResponse {
    status: string;
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    results: number;
    data: {
        data: IEmailLog[];
    };
}

export interface IEmailLogStats {
    total: number;
    opened: number;
    invalidAddress: number;
    openRate: number;
    typeDistribution: Array<{
        _id: string;
        count: number;
        opened: number;
    }>;
}
